module.exports = __webpack_public_path__ + "static/media/link.6937e3e2.svg";